import { BaseUrlBuilder } from './BaseUrlBuilder';

export class ApiUrlBuilder extends BaseUrlBuilder {
  public adminLogin() {
    return this.buildUrl('/v1/admin/auth');
  }

  public adminCoupons(query: { top: number; skip: number; orderby?: string; filter?: string }) {
    return this.buildUrl('/v1/admin/coupons', { query });
  }

  public adminGenerateCoupons(count: number) {
    return this.buildUrl(`/v1/admin/coupons/generate/${count}`);
  }

  public consumerVerify() {
    return this.buildUrl('/v1/brick/verify');
  }

  public consumerStartArt() {
    return this.buildUrl('/v1/brick/start');
  }

  public consumerSendPDF() {
    return this.buildUrl('/v1/brick/send');
  }

  public consumerSaveArtStep() {
    return this.buildUrl('/v1/brick/save');
  }

  public consumerGenerateArt() {
    return this.buildUrl('/v1/brick/generate');
  }

  public consumerResumeArt(sessionId: string) {
    return this.buildUrl(`/v1/brick/resume/${sessionId}`);
  }

  public consumerSkipStepsArt(sessionId: string, skip: number) {
    return this.buildUrl(`/v1/brick/resume/${sessionId}/${skip}`);
  }

  public consumerCreateArt() {
    return this.buildUrl('/v1/brick/create');
  }

  public consumerDownloadPDF() {
    return this.buildUrl('/v1/brick/pdf/download');
  }
}
